import React, { useEffect, useState } from "react";
import {
  formatABN,
  formatAccountNumber,
  formatBSBNumber,
  formatedAddress,
  formatMobile,
  formatNumber,
  formatPhone,
  formatSubcontractorName,
} from "../../lib/Misc";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { CardTitle } from "../../components/ui/card";
import {
  API,
  cddOptions,
  get,
  riskProfile,
  verificationMethods,
} from "../../config";

const SupplierDetailsPopup = ({
  supplierId,
  // toggleShowModal,
  showView,
  setShowView,
}) => {
  const [supplierDetail, setSupplierDetail] = useState(null);
  const [supplierLoading, setSupplierLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await get(`${API.SUPPLIER_DETAILS}/` + supplierId);
        setSupplierDetail(data.data);
        setSupplierLoading(false);
      } catch (e) {
        return null;
      }
    }
    fetchData();
  }, [supplierId, setSupplierDetail]);

  return (
    <ResponsiveDrawerForm
      description={""}
      title={"Supplier Details"}
      handleOpen={() => {}}
      handleClose={() => {}}
      className={"md:w-[65vw]"}
      open={showView}
      buttonClassName={""}
      setOpen={setShowView}
      read={true}
    >
      {supplierLoading ? (
        <Spin full expand={true} />
      ) : (
        <div className="md:p-0 p-4">
          <div className="modal-content">
            <CardTitle className="text-md mb-2">Personal Details</CardTitle>
            <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
              <p>
                <strong>First Name:</strong>{" "}
                {supplierDetail?.first_name ? supplierDetail?.first_name : "-"}
              </p>
              <p>
                <strong>Last Name:</strong> {supplierDetail?.last_name}
              </p>
              <p>
                <strong>Email Address:</strong> {supplierDetail?.email}
              </p>
              <p>
                <strong>Phone Number:</strong>{" "}
                {supplierDetail?.phone
                  ? formatPhone(supplierDetail?.phone)
                  : ""}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {supplierDetail?.mobile
                  ? formatMobile(supplierDetail?.mobile)
                  : "-"}
              </p>
              <p>
                <strong>Business Name:</strong>{" "}
                {supplierDetail?.business_name
                  ? supplierDetail?.business_name
                  : "-"}
              </p>

              <p>
                <strong>ABN:</strong>{" "}
                {supplierDetail?.abn ? formatABN(supplierDetail?.abn) : "-"}
              </p>
              <p>
                <strong>Code:</strong>{" "}
                {supplierDetail?.code ? supplierDetail?.code : "-"}
              </p>
              <p>
                <strong>Licence Number:</strong>{" "}
                {supplierDetail?.license_number
                  ? supplierDetail?.license_number
                  : "-"}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Address:</strong>{" "}
                {formatedAddress(
                  supplierDetail?.street,
                  supplierDetail?.suburb?.name,
                  supplierDetail?.state?.name,
                  supplierDetail?.postal_code
                )}
              </p>
              <p className="flex gap-1">
                <strong className="whitespace-nowrap">Street Address:</strong>{" "}
                {formatedAddress(
                  supplierDetail?.shipping_street,
                  supplierDetail?.shipping_suburb?.name,
                  supplierDetail?.shipping_state?.name,
                  supplierDetail?.shipping_postal_code
                )}
              </p>
            </div>
          </div>
          {supplierDetail?.account_name && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Bank Account Details
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                <p>
                  <strong>Bank Name:</strong>{" "}
                  {supplierDetail?.bank
                    ? supplierDetail?.bank?.abbreviation +
                      "-" +
                      supplierDetail?.bank?.name
                    : "-"}
                </p>
                <p>
                  <strong>Bank Account Name:</strong>{" "}
                  {supplierDetail?.account_name
                    ? supplierDetail?.account_name
                    : "-"}
                </p>
                <p>
                  <strong>BSB:</strong>{" "}
                  {supplierDetail?.bsb
                    ? formatBSBNumber(supplierDetail?.bsb)
                    : "-"}
                </p>
                <p>
                  <strong>Account Number:</strong>{" "}
                  {supplierDetail?.account_number
                    ? formatAccountNumber(supplierDetail?.account_number)
                    : "-"}
                </p>
                <p>
                  <strong>Opening Balance:</strong>{" "}
                  {supplierDetail?.opening_balance
                    ? "$" +
                      formatNumber(Number(supplierDetail?.opening_balance))
                    : "$0.00"}
                </p>
              </div>
            </div>
          )}

          {supplierDetail?.kyc && (
            <div className="modal-content mt-4">
              <CardTitle className="text-md mb-2">
                Proof of ID for Customer Due Diligence (CDD)
              </CardTitle>
              <div className="modal-content-details grid grid-cols-1 md:grid-cols-2 gap-3">
                {supplierDetail?.kyc?.photo_id && (
                  <p>
                    <strong>Photo ID:</strong>{" "}
                    <a
                      href={supplierDetail.kyc.photo_id}
                      download
                      target="_blank"
                      className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                )}
                {supplierDetail?.kyc?.primary_id && (
                  <p>
                    <strong>Primary ID:</strong>{" "}
                    <a
                      href={supplierDetail.kyc.primary_id}
                      download
                      target="_blank"
                      className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                )}
                {supplierDetail?.kyc?.secondary_id && (
                  <p>
                    <strong>Secondary ID:</strong>{" "}
                    <a
                      href={supplierDetail.kyc.secondary_id}
                      download
                      target="_blank"
                      className="inline-flex items-center rounded-lg bg-webPrimary px-2 py-1 text-sm font-medium text-white hover:bg-primary/90 transition-colors"
                      rel="noreferrer"
                    >
                      Download
                    </a>
                  </p>
                )}
                <p>
                  <strong>Verification Date:</strong>{" "}
                  {supplierDetail?.kyc?.verification_date
                    ? supplierDetail?.kyc?.verification_date
                    : "-"}
                </p>
                <p>
                  <strong>Verified By:</strong>{" "}
                  {supplierDetail?.kyc?.verified_by_user
                    ? formatSubcontractorName(
                        supplierDetail?.kyc?.verified_by_user
                      )
                    : "-"}
                </p>
                <p>
                  <strong>Method:</strong>{" "}
                  {supplierDetail?.kyc?.method
                    ? verificationMethods?.find(
                        (item) => item.value === supplierDetail?.kyc?.method
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>Risk Profile:</strong>{" "}
                  {supplierDetail?.kyc?.risk
                    ? riskProfile?.find(
                        (item) => item.value === supplierDetail?.kyc?.risk
                      )?.label
                    : "-"}
                </p>
                <p>
                  <strong>CDD:</strong>{" "}
                  {supplierDetail?.kyc?.cdd
                    ? cddOptions?.find(
                        (item) => item.value === supplierDetail?.kyc?.cdd
                      )?.label
                    : "-"}
                </p>
              </div>
            </div>
          )}
        </div>
      )}
    </ResponsiveDrawerForm>
  );
};

export default SupplierDetailsPopup;
